import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import Badge from '@mui/material/Badge';
import constants from 'helpers/constants';
import utils from 'helpers/utils';

const StyledBadge = styled(Badge)
  .attrs((props) => {
    let attr = props;

    const buttonColorVars = props.theme.color2Css('MuiBadge-badge', null, props.color, {
      varPrefix: 'badge',
      variables: true,
      type: constants.colorTypes.button
    });

    attr = utils.styleProps(attr, buttonColorVars.vars, {buttonColor: buttonColorVars.css});

    const vars = {
      '--badge-disabled-color': props.theme.property('palette.background.paper'),
      '--badge-disabled-background-color': props.theme.state2Color(props.color, 'disabled', constants.colorTypes.button, constants.colorTargets.background)
    };

    return utils.styleProps(attr, vars);
  })`
  .MuiBadge-badge {
    ${props => props.$css.buttonColor}
  }

  &.Badge-inline, &.Badge-inlineDot {
    .MuiBadge-badge {
      position: unset;
      transform: unset;
    }
    &:has(.Skeleton) {
      margin-top: 0 !important;
    }
    .Skeleton {
      align-self: center;
      margin-top: ${props => props.theme.layout(1)};
    }
  }
  
  .Skeleton {
    padding: 0 ${props => props.theme.spacing(6/8)};
    border-radius: ${props => props.theme.radius(2.5)};
    transform: scale(0.9, 0.9) !important;
  }
  
  &.Badge-size-small {
    >.MuiBadge-standard, > .MuiBadge-inline {
      font-size: ${props => props.theme.fontSize(11)};
      padding: ${props => props.theme.layout(1)} ${props => props.theme.layout('0.5sp')} 0 ${props => props.theme.layout('0.5sp')};
      min-width: ${props => props.theme.layout(16)};
      height: ${props => props.theme.layout(16)};
    }
  }
  &.Badge-size-smaller {
    >.MuiBadge-standard, > .MuiBadge-inline {
      font-size: ${props => props.theme.fontSize(10)};
      padding: 0 ${props => props.theme.layout('0.4sp')} 0 ${props => props.theme.layout('0.45sp')};
      min-width: ${props => props.theme.layout(14)};
      height: ${props => props.theme.layout(14)};
    }
  }

  &.Badge-clickable {
    > .MuiBadge-badge {
      cursor: pointer;

      &:has(.Span) {
        position: relative;
      }
      
      > .Span {
        &:before {
          content: '';
          display: inline-block;
          z-index: 1;
          width: 100%;
          height: 100%;
          position: absolute;
          left: 0;
          top: 0;
        }
      }
    }
  }
  
  &.Badge-disabled {
    > .MuiBadge-badge {
      pointer-events: none;
      color: ${props => props.$css.$var('--badge-disabled-color')};
      background-color: ${props => props.$css.$var('--badge-disabled-background-color')};
    }
  }

  &.Badge-hover {
    &:not(:has(> *:first-child:hover)) {
      .MuiBadge-badge {
        display: none;
      }
    }
  }
  
  ${ComponentStyles}
`;

StyledBadge.propTypes = {
  theme: PropTypes.object
};

export default StyledBadge;
